/* eslint-disable no-param-reassign */
import DateFnsUtils from '@date-io/date-fns';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import LocalizedText, { localize } from 'commons/LocalizedText/LocalizedText';
import React, { useEffect, useState } from 'react';
import { isValidDate } from 'utils/processing/dates';


const useStyles = makeStyles((theme) => ({
  generalValue: {
    minWidth: '300px',
    marginTop: '7px',
    "& .MuiInputBase-root": {
      "& .MuiInputBase-input": {
        padding: 10
      }
    }
  },
  modifiedTextField: {
    '& fieldset': {
      borderColor: '#31A597 !important',
      borderWidth: '2px'
    }
  },
  errorTextField: {
    '& fieldset': {
      borderColor: '#ff0000 !important',
      borderWidth: '2px'
    }
  }
}
));


export const DatePickerWithLabel = ({
  startsModified,
  isRequired = false,
  label,
  value,
  enableColorChangeOnModification,
  onChange
}) => {
  const classes = useStyles();
  const dateFormat = 'dd-MM-yyyy';
  const [isModified, setIsModified] = useState(startsModified);
  const [dateError, setDateError] = useState(false);

  const handleOnChange = (value) => {
    onChange(value);
    if(enableColorChangeOnModification) setIsModified(true);
  }

  useEffect(() => {
    if(!isRequired && value === null){
      setDateError(false);
      return;
    }
    setDateError(!isValidDate(value));
  }, [isRequired, value]);

  return (
    <Grid item>
      <Grid alignItems='center' className={classes.generalContainer} container justifyContent='space-between' spacing={2} wrap='nowrap'>
        <Grid item xs={6}>
          <LocalizedText align="right" fontWeight="bold" isTextLabel>
            {label}
          </LocalizedText>
        </Grid>
        <Grid item xs={6}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Grid item>
              <KeyboardDatePicker
                autoOk
                className={`${classes.generalValue}
                      ${dateError ? classes.errorTextField : ''}
                      ${isModified ? classes.modifiedTextField : ''}`}
                format={dateFormat}
                helperText=""
                id="date-picker-outlined"
                InputLabelProps={{
                  shrink: true
                }}
                inputVariant="outlined"
                invalidDateMessage={dateError}
                label={localize(dateFormat)}
                margin="normal"
                onChange={e => handleOnChange(e)}
                value={value}
              />
            </Grid>
          </MuiPickersUtilsProvider>
        </Grid>
      </Grid>
    </Grid>
  );
};